module.exports = __webpack_public_path__ + "img/swiper1_d.b8f53e52.png";